module.exports = __webpack_public_path__ + "static/humain_resources-9a172fccc3e682158369f5577b488ed2.jpg";